import { ReactNode } from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import { Colors } from '../helpers';

interface ButtonOptionProps {
    label: ReactNode;
    disabled?: boolean;
    checked?: boolean;
    addIcon?: ReactNode;
    removeIcon?: ReactNode;
    onClick?: (checked: boolean) => void;
    backgroundColor?: string;
}

export default ({ label, onClick, disabled, checked, addIcon, removeIcon, backgroundColor }: ButtonOptionProps) => {
    const classes = useStyles({ checked, disabled, backgroundColor });

    return <Box py={3.5} px={2.5} className={classes.optionContainer} onClick={() => !disabled && onClick && onClick(!checked)}>
        <span className={classes.optionLabel}>{label}</span>
        <Button
            disableElevation
            type="button"
            variant="contained"
            color={checked ? 'primary' : 'default'}
            disabled={disabled}
            className={classes.addButton}
            endIcon={checked ? <>{removeIcon ? removeIcon : <CheckIcon />}</> : <>{addIcon ? addIcon : <AddIcon />}</>}
            onClick={() => onClick && onClick(!checked)}>
            {!checked && 'Add'}
        </Button>
    </Box>
}

const useStyles = makeStyles({
    optionContainer: ({ disabled, backgroundColor }: { checked?: boolean; disabled?: boolean, backgroundColor?: string }) => ({
        display: 'flex',
        alignItems: 'center',
        borderRadius: '0.75rem',
        backgroundColor: backgroundColor || Colors.LightGrey,
        cursor: disabled ? 'default' : 'pointer',
        userSelect: 'none'
    }),
    optionLabel: ({ disabled }: { checked?: boolean; disabled?: boolean }) => ({
        paddingRight: 10,
        color: disabled ? Colors.Grey : Colors.Blue,
        fontWeight: 500,
        fontSize: '1.1rem',
        flexGrow: 1
    }),
    addButton: ({ checked }: { checked?: boolean; disabled?: boolean }) => ({
        height: 45,
        minWidth: 45,
        paddingLeft: checked ? 0 : '1.125rem',
        paddingRight: checked ? 0 : '1.125rem',
        '& .MuiButton-endIcon': {
            marginLeft: 0,
            marginRight: checked ? 0 : -4,
            '& > svg': {
                fontSize: checked ? 24 : 20
            }
        }
    })
}, { name: 'ButtonOption' });
